import { ToastContainer } from "react-toastify";
import "./App.css";
import MainRoutes from "./route/MainRoutes";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <>
      <div className="App">
        <MainRoutes />
      </div>
      <ToastContainer />
    </>
  );
}

export default App;
